export enum CardType {
  Full = 'FullBackgroundImage', // Drive-Thru Card
  Half = 'HalfBackgroundImage', // Drive-Thru Card
  Embedded = 'EmbeddedImage', // Drive-Thru Card
  HeaderImage = 'HeaderImage', // Featured Category Card
  HeaderImageCarousel = 'HeaderImageCarousel', // Featured Category Card
  ProductDealCarousel = 'ProductDealCarousel' // Featured Category Card
}
